import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MessageService } from 'app/shared/services';

@Component({
  selector: 'app-message-container',
  imports: [CommonModule],
  templateUrl: './message-container.html',
  styleUrl: './message-container.scss'
})
export class MessageContainer {
  private messageService = inject(MessageService);

  list = computed(() => this.messageService.messages());

  alertClass(type: string) {
    return `message-type-${type}`;
  }

  close(id: number) {
    this.messageService.close(id);
  }
}
